"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var index_1 = require("./index");
var useContext = React.useContext;
var capitalize = function (text) { return text.charAt(0).toUpperCase() + text.slice(1); };
exports.default = (function () {
    var _a = useContext(index_1.AppContext), bundleType = _a.bundleType, goNext = _a.goNext, reason = _a.reason, setReason = _a.setReason;
    var askReasonsForBundleTypes = ['Diaper', 'Training Pant', 'Fundamentals'];
    var cancel = window.accountApp.settings.cancel;
    // diaper and training pant bundles only for now
    if (!bundleType || !askReasonsForBundleTypes.includes(bundleType)) {
        goNext();
        return null;
    }
    var filteredReasons = (function () {
        switch (bundleType) {
            case 'Fundamentals':
                return ['price', 'freq', 'perf', 'store', 'other'].map(function (k) { return index_1.reasons.find(function (r) { return r.key === k; }); });
            case 'Diaper':
                // filter out econ as a reason
                return index_1.reasons.filter(function (cancellationReason) {
                    return cancellationReason.key !== 'econ';
                });
            default:
                return index_1.reasons;
        }
    })();
    return (React.createElement("div", { id: 'cancel-reason-choices', className: 'padding-4 medium-padding-8' },
        React.createElement("div", { className: 'text-center margin-bottom-16' },
            React.createElement("div", { className: 'margin-bottom-4 font-lighter' }, cancel.reasonChoiceTitle),
            React.createElement("h3", null, cancel.reasonChoiceBody),
            React.createElement("div", { className: 'divider bg-cornflower-blue margin-vertical-4 margin-horizontal-auto' })),
        React.createElement("div", { className: 'grid-x grid-margin-x grid-margin-y align-center' }, filteredReasons.map(function (r) { return (React.createElement(react_router_dom_1.NavLink, { id: "cancel-reason-choice-".concat(r.key), to: '#', replace: true, className: 'cell small-6 medium-4 text-center', key: r.key, onClick: function () { return setReason(r); } },
            React.createElement("img", { className: (0, classnames_1.default)('display-inline-block margin-bottom-2', (reason === null || reason === void 0 ? void 0 : reason.key) !== r.key && 'filter-gray'), src: cancel["reasonImageUrl".concat(capitalize(r.key))], alt: r.title, style: { width: 90 } }),
            React.createElement("br", null),
            React.createElement("span", { className: 'text-nobel h6-7' }, r.title))); })),
        React.createElement("div", { className: 'margin-top-8 text-center' },
            React.createElement("button", { className: 'button wisteria text-uppercase padding-vertical-5 padding-horizontal-8', disabled: !reason, onClick: goNext }, cancel.reasonChoiceButton))));
});
